import React from 'react';
import styles from './styles.module.css';

interface ValueProps {
  itemKey: string | number;
  children: React.ReactNode;
}

const Value: React.FC<ValueProps> = ({ itemKey, children }) => {
  const wrapperRef = React.useRef(null);

  return (
    <div ref={wrapperRef} className={styles.gridItem} key={itemKey}>
      <div className={styles.gridWrapper}>
        <p>{children}</p>
      </div>
    </div>
  );
};

export default Value;
